// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__7zOCw","spin":"styles_spin__3ODrb"};